import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useCountry } from '@/contexts/CountryContext';
import { SummerSparkles } from '@/components/SummerSparkles';

// Summer replacement for the Christmas banner section
export const SummerSeasonOffers = () => {
  const { country } = useCountry();
  return (
    <section className="py-16 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-2xl p-12 text-center text-white overflow-hidden"
             style={{ background: 'linear-gradient(90deg, hsl(199 89% 48%) 0%, hsl(155 100% 33%) 50%, hsl(28 90% 55%) 100%)' }}>
          <SummerSparkles count={28} color="white" />
          <div className="absolute top-4 left-4 text-4xl">☀️</div>
          <div className="absolute top-4 right-4 text-4xl">🌴</div>
          <div className="absolute bottom-4 left-8 text-3xl">🌊</div>
          <div className="absolute bottom-4 right-8 text-3xl">⛵️</div>
          <div className="relative z-10">
            <div className="text-4xl mb-4">☀️ 🏖️ 🍸</div>
            <h2 className="font-heading text-3xl font-bold mb-4">
              Summer in {country.name} — Exclusive Beach Season Offers!
            </h2>
            <p className="text-xl mb-8 text-white/90 max-w-2xl mx-auto">
              Celebrate summer across the Balkans! Special seasonal rates on boutique hotels,
              beach clubs, lake escapes and guided tours — only on InfoPoint.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="default" size="lg" asChild className="bg-white text-[#00AA6C] hover:bg-gray-100">
                <Link to="/search?deals=summer">☀️ Explore Summer Deals</Link>
              </Button>
              <Button variant="outline" size="lg" asChild className="border-white text-white hover:bg-white/10">
                <Link to="/claim">Claim Business</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
